import React, { useEffect } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBarcode, faCheck, faTable, faWrench, faGavel, faHistory, faChartLine, faArrowAltCircleUp, faExclamationCircle, faRedoAlt, faTimes, faExpandArrowsAlt, faThLarge, faList, faSort, faSortUp, faSortDown, faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons';
import AuctionCore, { AuctionCoreContext } from './agent';

import Routes from './routes';
import Analytics from './hooks/utils/analytics';

library.add(faBarcode, faGavel, faTable, faHistory, faWrench, faChartLine, faCheck, faArrowAltCircleUp, faExclamationCircle, faRedoAlt, faTimes, faExpandArrowsAlt, faThLarge, faList, faSort, faSortUp, faSortDown, faQuestionCircle);

const App = () => {
  useEffect(() => {
    Analytics.initialize();
    const path = window.location.pathname + window.location.search;
    Analytics.RecordPageView(path, path);
  }, []);

  return (
    <AuctionCoreContext.Provider value={new AuctionCore()}>
      <Routes />
    </AuctionCoreContext.Provider>
  );
};

export default App;
